import { createSvgIcon } from '@automata/mui-theme';
export const ThermoFisherFlouroskanIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.5 64C44.0523 64 44.5 64.4477 44.5 65V69.5C44.5 70.0523 44.0523 70.5 43.5 70.5C42.9477 70.5 42.5 70.0523 42.5 69.5V65C42.5 64.4477 42.9477 64 43.5 64Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27 54C27.5523 54 28 54.4477 28 55V60.5C28 61.0523 27.5523 61.5 27 61.5C26.4477 61.5 26 61.0523 26 60.5V55C26 54.4477 26.4477 54 27 54Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6364 29.4963C14.9147 29.0192 15.527 28.8581 16.004 29.1364L52.004 50.1364C52.4811 50.4147 52.6422 51.027 52.3639 51.504C52.0857 51.9811 51.4733 52.1422 50.9963 51.8639L14.9963 30.8639C14.5192 30.5857 14.3581 29.9733 14.6364 29.4963Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.7597 9.47873C48.5341 9.0395 49.4837 9.04527 50.2527 9.49387L85.2597 29.9146C86.0277 30.3627 86.5 31.1849 86.5 32.0741V64.4213C86.5 65.3159 86.0221 66.1422 85.2467 66.5883L49.7502 87.011C48.9737 87.4577 48.0176 87.4548 47.2438 87.0035L12.2403 66.5848C11.4723 66.1368 11 65.3145 11 64.4253V52.4804C11 42.5932 11 38.3703 13.9532 29.3989C14.146 28.8133 14.5519 28.3129 15.0939 28.0056L47.7597 9.47873ZM48.9895 12.2301L16.743 30.5192C14.0019 38.9006 14 42.746 14 52.4997V64.1381L48.5052 84.2662L83.5 64.1322V32.3613L48.9895 12.2301Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.8642 30.9971C86.1421 31.4744 85.9804 32.0866 85.5031 32.3644L52.2654 51.7117C50.0766 56.3041 49.5 63.105 49.5 66.0002V86.0002C49.5 86.5524 49.0523 87.0002 48.5 87.0002C47.9477 87.0002 47.5 86.5524 47.5 86.0002V66.0002C47.5 63.0085 48.0785 55.8362 50.467 50.8364C50.6419 50.4704 50.9219 50.1796 51.2548 49.9858L84.4969 30.6359C84.9742 30.3581 85.5864 30.5198 85.8642 30.9971Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.6373 22.9948C27.9164 22.5182 28.529 22.3582 29.0056 22.6373L63.3906 42.7771C64.1176 43.2029 64.5289 44.0626 64.3164 44.9312C63.6279 47.7466 61.6958 53.1087 58.1645 56.2476C54.9369 59.1166 53.2345 61.5417 52.6251 65.166C52.5768 65.4538 52.5351 65.7503 52.5002 66.0563V70.5002C52.5002 71.0524 52.0525 71.5002 51.5002 71.5002C50.9479 71.5002 50.5002 71.0524 50.5002 70.5002V66.5512L48.8302 67.2396C48.2633 67.4733 47.6205 67.4341 47.0863 67.1331L12.0093 47.3714C11.5282 47.1003 11.3578 46.4905 11.6289 46.0093C11.9 45.5281 12.5098 45.3578 12.991 45.6289L48.068 65.3906L50.7547 64.2831C51.5477 60.3531 53.5629 57.662 56.8358 54.7528C59.8878 52.0399 61.6959 47.2039 62.3644 44.4938L27.9948 24.363C27.5182 24.0839 27.3582 23.4713 27.6373 22.9948Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M85.3721 52.0105C85.6425 52.492 85.4714 53.1016 84.9899 53.3721L48.9864 73.5932C48.3708 73.939 47.6184 73.9345 47.0069 73.5814L12.0001 53.3662C11.5218 53.09 11.358 52.4784 11.6342 52.0001C11.9104 51.5218 12.522 51.358 13.0002 51.6342L48.007 71.8494L84.0105 51.6283C84.492 51.3578 85.1016 51.5289 85.3721 52.0105Z"
    />
  </svg>,
  'ThermoFisherFlouroskanIcon'
);
